<template>
  <div id="dataSize">
    <dv-full-screen-container class="screenContainer" :key="key">
      <dv-loading v-show="dvLoad">Loading...</dv-loading>
      <div class="headerClass">
        <div class="headerTitle">
          违规数据大屏  |  {{userData.realname}}
        </div>
        <div class="headerTime">
          <i class="el-icon-time"></i>
          统计时间：{{ dataTime }}
        </div>
      </div>
      <div class="platClass">
        <div v-for="item in platList" :class="item.class" @click="platClick(item)">
          {{ item.name }}
        </div>
      </div>
      <dv-decoration-5 id="cnm" style="width:100%;height:40px;" :dur="10"/>
      <el-row>
        <!-- 本月链接违规量 -->
        <el-col :span="8">
          <div style="margin: 40px 0px 60px 70px;">
            <div style="height: 165px;float: left;width: 60%;">
              <div style="color: rgba(255, 255, 255, 0.6);font-size: 18px;margin-top: 10px;">
                本月链接违规量
              </div>
              <dv-digital-flop :config="digitalConfig" style="width:100%;height:80px;" />
              <div style="color: rgba(255, 255, 255, 0.6);font-size: 14px;">
                较上月同期：
                <span style="color: green;" v-if="onratenum.indexOf('-') != -1">
                  {{ onratenum }}<i class="el-icon-caret-top"></i>
                </span>
                <span style="color: red;" v-else>
                  {{ onratenum }}<i class="el-icon-caret-bottom"></i>
                </span>
              </div>
            </div>
            <div style="height: 165px;float: right;width: 40%;">
              <div style="width:calc(100% - 30px);text-align: center;color: rgba(255, 255, 255, 0.6);margin-bottom: 10px;">{{ $store.state.globalLowPrice }}率</div>
              <dv-percent-pond :config="waterConfig" style="width:calc(100% - 30px);height:100px;" />
            </div>
            <!-- <div class="liangOne">
              昨日链接违规量
              <div style="font-size: 22px;padding-bottom: 4px;">
                {{ yesterdayMap }}
              </div>
            </div> -->
            <div class="liangTwo">
              <div style="float: left;width:50%;">
                本年链接违规量
              </div>
              <dv-percent-pond :config="waterConfig2" style="width:50%;height:65px;float: right;" />
              <div style="font-size: 22px;float: left;width:50%;">
                {{ lowpriceYearSeries }}
              </div>
              
            </div>
          </div>

        </el-col>
        <!-- 违规链接管理趋势 -->
        <el-col :span="8" v-show="platValue == 'All'">
          <div style="margin: 20px 35px;color: white;font-size: 24px;">
            违规链接管理趋势
          </div>
          <div id="main" style="height: 300px;width: 100%;"></div>
        </el-col>
        <!-- 违规链接平台分布 -->
        <el-col :span="8" v-show="platValue == 'All'">
          <div style="margin: 20px 35px;color: white;font-size: 24px;">
            违规链接平台分布
          </div>
          <dv-active-ring-chart :config="chartConfig" style="width:100%;height:300px" />
        </el-col>
        <el-col :span="16" v-show="platValue != 'All'">
          <div style="margin: 20px 35px;color: white;font-size: 24px;">
            违规链接管理趋势
          </div>
          <!-- <div style="height: 300px;"> -->
            <div id="main2" style="height: 300px;width: 1300px;"></div>
          <!-- </div> -->
        </el-col>
      </el-row>
      <!-- 下半段分界线 -->
      <!-- 下半段分界线 -->
      <!-- 下半段分界线 -->
      <el-row style="margin: 40px 0px 0px 0px;color: white;font-size: 24px;">
        <el-col :span="8">
          <div style="margin-left: 70px;margin-bottom: 60px;">
            <img src="../assets/img/dataSize/jiangbei.png" class="jiangbeiClass">
            <div class="jiangbeiTitle">
              经销商违规量排行
            </div>
            <div style="float: right;">
              <div v-for="item in wgPx" :class="item.class" @click="wgClick(item)">
                {{ item.name }}
              </div>
            </div>
          </div>
          <dv-scroll-ranking-board :config="dealerRanking" style="width:calc(100% - 105px);height:300px;margin: 0px 35px 20px 70px;" v-if="dealerRankingName == '本月累积'"/>
          <dv-scroll-ranking-board :config="dealerRankingYear" style="width:calc(100% - 105px);height:300px;margin: 0px 35px 20px 70px;" v-else/>
        </el-col>
        <el-col :span="8">
          <div style="margin-left: 35px;margin-bottom: 60px;">
            <img src="../assets/img/dataSize/jiangbei.png" class="jiangbeiClass">
            <div class="jiangbeiTitle">
              店铺违规量排行
            </div>
            <div style="float: right;">
              <div v-for="item in dpPx" :class="item.class" @click="dpClick(item)">
                {{ item.name }}
              </div>
            </div>
          </div>
          <dv-scroll-ranking-board :config="shopRanking" style="width:calc(100% - 70px);height:300px;margin: 0px 35px 20px 35px;" v-if="shopRankingName == '本月累积'"/>
          <dv-scroll-ranking-board :config="shopRankingYear" style="width:calc(100% - 105px);height:300px;margin: 0px 35px 20px 70px;" v-else/>
        </el-col>
        <el-col :span="8">
          <div style="margin-left: 35px;margin-bottom: 60px;">
            <img src="../assets/img/dataSize/jiangbei.png" class="jiangbeiClass">
            <div class="jiangbeiTitle">
              链接违规量排行
            </div>
            <div style="float: right;margin-right: 38px;">
              <div v-for="item in ljPx" :class="item.class" @click="ljClick(item)">
                {{ item.name }}
              </div>
            </div>
          </div>
          <dv-scroll-ranking-board :config="linknameRanking" style="width:calc(100% - 105px);height:300px;margin: 0 70px 20px 35px;"  v-if="linknameRankingName == '本月累积'"/>
          <dv-scroll-ranking-board :config="linknameRankingYear" style="width:calc(100% - 105px);height:300px;margin: 0 70px 20px 35px;"  v-else/>
        </el-col>
      </el-row>
      
    </dv-full-screen-container>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        key: 11,
        platValue: 'All',
        platList: [{
          name: '全部平台',
          value: 'All',
          class: 'actItem',
          index: 0,
        }],
        wgPx: [{
          name: '本月累积',
          value: 'month',
          class: 'actItem2',
        },{
          name: '本年累计',
          value: 'year',
          class: 'noItem2',
        }],
        dpPx: [{
          name: '本月累积',
          value: 'month',
          class: 'actItem2',
        },{
          name: '本年累计',
          value: 'year',
          class: 'noItem2',
        }],
        ljPx: [{
          name: '本月累积',
          value: 'month',
          class: 'actItem2',
        },{
          name: '本年累计',
          value: 'year',
          class: 'noItem2',
        }],
        dealerRanking: {
          waitTime: "3000",
          data: [],
        },
        dealerRankingYear: {
          waitTime: "3000",
          data: [],
        },
        linknameRanking: {
          waitTime: "3000",
          data: [],
        },
        linknameRankingYear: {
          waitTime: "3000",
          data: [],
        },
        shopRanking: {
          waitTime: "3000",
          data: [],
        },
        shopRankingYear: {
          waitTime: "3000",
          data: [],
        },
        chartConfig: {
          data: [],
          digitalFlopStyle: {
            fontSize: 22,
          },
          color: ['#4727EA','#1E2AFF','#3451AF','#3D71FF','#5776ED','#2396FF','#00AFFF','#A1CBFD','#01E9FF','#8FF6EB','#92FEC0','#ACECFF']
        },
        waterConfig: {
          value: 66,
          colors: ['#87A8FF','#1755FF'],
        },
        waterConfig2: {
          value: 0,
          colors: ['#9FB8FF','#E6EDFF'],
        },
        digitalConfig: {
          number: [0],
          content: '{nt}',
          textAlign: 'left',
          style: {
            fontSize: 50,
            fill: '#FFFFFF'
          }
        },
        lowpriceResultSeries: {}, //"${this.$store.state.globalLowPrice}率"
        lowpriceSeries: {}, //"违规量"
        lowpriceYearSeries: 0,
        yesterdayMap: 0,
        onratenum: '',
        lowpriceResultYearSeries: {},
        ratenum: {},
        sameMonthnum: {},
        yesterdayData: {},
        onratenumData: {},
        lowpriceYear: {},
        monthMap: {},
        yearMap: {},
        dvLoad: true,
        platNum: 0,
        clearTime: null,
        dataTime: '',
        userData: {},
        dealerRankingName: '本月累积',
        shopRankingName: '本月累积',
        linknameRankingName: '本月累积',
      };
    },
    mounted() {
      this.userData =JSON.parse(localStorage.getItem('userData'))
      console.log(JSON.parse(localStorage.getItem('userData')))
      if (this.userData.dateplatformStatus == '0') {
        this.$message({
          message: '暂无权限',
          type: 'warning'
        });
        return
      }
      let platArr = this.userData.dateplatform.split(',')
      console.log(platArr)
      for (let a in platArr) {
        if (platArr[a] == 'TB') {
          this.platList.push({
            value: platArr[a],
            name: '淘宝',
            class: 'noItem',
            index: a
          })
        } else if (platArr[a] == 'TM') {
          this.platList.push({
            value: platArr[a],
            name: '天猫',
            class: 'noItem',
            index: a
          })
        } else if (platArr[a] == 'JD') {
          this.platList.push({
            value: platArr[a],
            name: '京东',
            class: 'noItem',
            index: a
          })
        } else if (platArr[a] == 'SN') {
          this.platList.push({
            value: platArr[a],
            name: '苏宁',
            class: 'noItem',
            index: a
          })
        } else if (platArr[a] == 'PDD') {
          this.platList.push({
            value: platArr[a],
            name: '拼多多',
            class: 'noItem',
            index: a
          })
        } else if (platArr[a] == '1688') {
          this.platList.push({
            value: platArr[a],
            name: '1688',
            class: 'noItem',
            index: a
          })
        } else if (platArr[a] == 'DD') {
          this.platList.push({
            value: platArr[a],
            name: '当当',
            class: 'noItem',
            index: a
          })
        } else if (platArr[a] == 'DY') {
          this.platList.push({
            value: platArr[a],
            name: '抖音',
            class: 'noItem',
            index: a
          })
        } else if (platArr[a] == 'WPH') {
          this.platList.push({
            value: platArr[a],
            name: '唯品会',
            class: 'noItem',
            index: a
          })
        } else if (platArr[a] == 'YFW') {
          this.platList.push({
            value: platArr[a],
            name: '药房网',
            class: 'noItem',
            index: a
          })
        } else if (platArr[a] == 'HM') {
          this.platList.push({
            value: platArr[a],
            name: '盒马',
            class: 'noItem',
            index: a
          })
        } else if (platArr[a] == 'YYC') {
          this.platList.push({
            value: platArr[a],
            name: '1药城',
            class: 'noItem',
            index: a
          })
        } else if (platArr[a] == 'LZDVN') {
          this.platList.push({
            value: platArr[a],
            name: 'lazada越南',
            class: 'noItem',
            index: a
          })
        } else if (platArr[a] == 'LZDSG') {
          this.platList.push({
            value: platArr[a],
            name: 'lazada新加坡',
            class: 'noItem',
            index: a
          })
        } else if (platArr[a] == 'LZDMY') {
          this.platList.push({
            value: platArr[a],
            name: 'lazada马来西亚',
            class: 'noItem',
            index: a
          })
        }
      }
      const currentTime = new Date();
      const year = currentTime.getFullYear();
      let month = currentTime.getMonth() + 1
      let day = currentTime.getDate();
      if (month < 10) {
        month = '0' + month
      }
      if (day < 10) {
        day = '0' + day
      }
      
      this.dataTime = year + '-' + month + '-' + day
      this.largeScreen2()
    },
    created() {
      
    },
    beforeDestroy() {  
      // clearTimeout(this.clearTime);
    },  
    methods: {
      // 上半部分章子建数据源
      dataScreenAnalysis() {
        fetch({
          url: "hcm/dataPlatformday/dataScreenAnalysis",
          method: "post",
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.chartConfig.data = data.platformDataMap
            this.chartConfig = {...this.chartConfig}
            this.lowpriceResultSeries = data.lowpriceResultSeries[0] //"`${this.$store.state.globalLowPrice}率`"
            this.lowpriceSeries = data.lowpriceSeries[0] //"违规量"

            this.lowpriceYear = data.lowpriceYearSeries[0]
            this.lowpriceYearSeries = data.lowpriceYearSeries[0].lowpriceYearAll

            this.ratenum = data.ratenum[0]
            this.waterConfig.value = data.ratenum[0].ratenumAll
            this.waterConfig = {...this.waterConfig}
            
            this.lowpriceResultYearSeries = data.lowpriceResultYearSeries[0]

            this.waterConfig2.value = data.lowpriceResultYearSeries[0].lowpriceResultYearAll
            this.waterConfig2 = {...this.waterConfig2}

            this.sameMonthnum = data.sameMonthnum[0]
            this.digitalConfig.number[0] = data.sameMonthnum[0].sameMonthnumAll
            this.digitalConfig = {...this.digitalConfig}

            this.yesterdayData = data.yesterdayMap[0]
            this.yesterdayMap = data.yesterdayMap[0].yesterdaynumAll
            
            this.onratenumData = data.onratenum[0]
            this.onratenum = data.onratenum[0].onratenumAll
            // echart图
            let list = []
            list.push(
              data.lowpriceResultSeries[0].dataAll
            )
            list.push(
              data.lowpriceSeries[0].dataAll
            )
            if (list) {
              this.drawChart(list,data.lowpriceSeries[0].listAxis)
            }
            this.timeFun()
            this.dvLoad = false
          } else {
            this.$message({
              message: res.message,
              type: "error"
            });
          }
        }).catch(error => {
          this.$message.error('服务器错误~');
          this.dvLoad = false
        })
      },
      // 下半部分刘杰数据源
      largeScreen2() {
        let params = {}
        if (this.platValue == 'All') {
          
        } else {
          params.platform = this.platValue
        }
        fetch({
          url: "hcm/Index/largeScreen2",
          method: "get",
          noFormat: true,
          responseType: "text",
          params: params,
          timeout: 60 * 1000 * 60,
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.dataTime = data.statisticsDate
            this.monthMap = data.monthMap
            this.yearMap = data.yearMap

            this.dealerRanking.data = data.monthMap.dealerRankingAll
            this.dealerRankingYear.data = data.yearMap.dealerRankingAll

            this.linknameRanking.data = data.monthMap.linknameRankingAll
            this.linknameRankingYear.data = data.yearMap.linknameRankingAll

            this.shopRanking.data = data.monthMap.shopRankingAll
            this.shopRankingYear.data = data.yearMap.shopRankingAll

            this.dealerRanking = {...this.dealerRanking}
            this.dealerRankingYear = {...this.dealerRankingYear}
            this.linknameRanking = {...this.linknameRanking}
            this.linknameRankingYear = {...this.linknameRankingYear}
            this.shopRanking = {...this.shopRanking}
            this.shopRankingYear = {...this.shopRankingYear}
            this.dataScreenAnalysis()
            
          } else {
            this.$message({
              message: res.message,
              type: "error"
            });
          }
        })
      },
      // 平台改变样式并触发方法
      platClick(item) {
       for (let a in this.platList) {
          this.platList[a].class = 'noItem'
          if (item.name == this.platList[a].name) {
            this.platList[a].class = 'actItem'
            this.platValue = this.platList[a].value
          }
        }
        // 切换平台时所有数据都清空到默认状态
        this.wgPx[0].class = 'actItem2'
        this.wgPx[1].class = 'noItem2'
        this.dpPx[0].class = 'actItem2'
        this.dpPx[1].class = 'noItem2'
        this.ljPx[0].class = 'actItem2'
        this.ljPx[1].class = 'noItem2'
        if (item.index || item.index === 0) {
          // 清除定时器
          this.platNum = item.index
          this.clearFun()
        } else {
          this.timeFun()
        }
      },
      // 清除定时器
      clearFun() {
        if (this.clearTime) {
          clearTimeout(this.clearTime);
        }
        this.timeFun()
      },
       // 定时方法
      timeFun() {
        
        let list = []

        let ratenum = 'ratenum' + this.platValue
        this.waterConfig.value = this.ratenum[ratenum]
        this.waterConfig = {...this.waterConfig}

        let lowpriceResultYearSeries = 'lowpriceResultYear' + this.platValue
        this.waterConfig2.value = this.lowpriceResultYearSeries[lowpriceResultYearSeries]
        this.waterConfig2 = {...this.waterConfig2}

        let sameMonthnum = 'sameMonthnum' + this.platValue
        this.digitalConfig.number[0] = this.sameMonthnum[sameMonthnum]
        this.digitalConfig = {...this.digitalConfig}

        let lowpriceYear = 'lowpriceYear' + this.platValue
        this.lowpriceYearSeries = this.lowpriceYear[lowpriceYear]
        

        let yesterdaynum = 'yesterdaynum' + this.platValue
        this.yesterdayMap = this.yesterdayData[yesterdaynum]

        let onratenum = 'onratenum' + this.platValue
        this.onratenum = this.onratenumData[onratenum]

        let dealplatFrom = 'dealerRanking' + this.platValue
        let linkplatFrom = 'linknameRanking' + this.platValue
        let shopplatFrom = 'shopRanking' + this.platValue
        this.dealerRanking.data = this.monthMap[dealplatFrom]
        this.linknameRanking.data = this.monthMap[linkplatFrom]
        this.shopRanking.data = this.monthMap[shopplatFrom]

        this.dealerRanking = {...this.dealerRanking}
        this.linknameRanking = {...this.linknameRanking}
        this.shopRanking = {...this.shopRanking}

        let a = 'data' + this.platValue
        list.push(
          this.lowpriceResultSeries[a]
        )
        list.push(
          this.lowpriceSeries[a]
        )
        this.drawChart2(list,this.lowpriceSeries.listAxis)
        // 启动定时器
        // this.timerFun()
        
      },
      // // 启动定时器
      // timerFun() {
      //   // 给数组然后知道是哪个平台 定时器
      //   let that = this
      //   this.clearTime = setTimeout(() => {
      //     if (that.platNum == 8) {
      //       that.platNum = 0
      //     } else {
      //       that.platNum = Number(that.platNum) + 1
      //     }
      //     let item = {
      //       name: '',
      //     }
      //     item.name = that.platList[that.platNum].name
      //     that.platClick(item)
      //   }, 10000);
      // },
      // 经销商，店铺，链接排行按钮切换
      wgClick(item) {
        
        for (let a in this.wgPx) {
          this.wgPx[a].class = 'noItem2'
          if (item.name == this.wgPx[a].name) {
            this.wgPx[a].class = 'actItem2'
          }
        }
        this.dealerRankingName = item.name
        // let dealplatFrom = 'dealerRanking' + this.platValue
        // if (item.name == '本年累计') {
        //   this.dealerRanking.data = this.yearMap[dealplatFrom]
        // } else {
        //   this.dealerRanking.data = this.monthMap[dealplatFrom]
        // }
        // this.dealerRanking = {...this.dealerRanking}
        this.clearFun()
      },
      dpClick(item) {
        for (let a in this.dpPx) {
          this.dpPx[a].class = 'noItem2'
          if (item.name == this.dpPx[a].name) {
            this.dpPx[a].class = 'actItem2'
          }
        }
        this.shopRankingName = item.name
        // let shopplatFrom = 'shopRanking' + this.platValue
        // if (item.name == '本年累计') {
        //   this.shopRanking.data = this.yearMap[shopplatFrom]
        // } else {
        //   this.shopRanking.data = this.monthMap[shopplatFrom]
        // }
        // this.shopRanking = {...this.shopRanking}
        this.clearFun()
      },
      ljClick(item) {
        for (let a in this.ljPx) {
          this.ljPx[a].class = 'noItem2'
          if (item.name == this.ljPx[a].name) {
            this.ljPx[a].class = 'actItem2'
          }
        }
        this.linknameRankingName = item.name
        // let linkplatFrom = 'linknameRanking' + this.platValue
        // if (item.name == '本年累计') {
        //   this.linknameRanking.data = this.yearMap[linkplatFrom]
        // } else {
        //   this.linknameRanking.data = this.monthMap[linkplatFrom]
        // }
        // this.linknameRanking = {...this.linknameRanking}
        this.clearFun()
      },
      // 全部平台店铺销量分析
      drawChart(list,dateList) {
        // 基于准备好的dom，初始化echarts实例  这个和上面的main对应
        let myChart = this.$echarts.init(document.getElementById("main"));
        // 指定图表的配置项和数据
        let option = {
          tooltip: {
            trigger: 'axis',
          },
          legend: {
            data: ["违规量",`${this.$store.state.globalLowPrice}率`],
            textStyle: {
              color: '#66687C',   // 设置图例文本颜色
            }
          },
          xAxis: {
            type: 'category',
            data: dateList,
            axisPointer: {
              type: 'shadow'
            },
            axisLabel: {
              color: "#66687C",
            },
            axisLine: {
              lineStyle: {
                color: '#66687C'   // 将刻度线颜色修改为红色
              }
            },
          },
          yAxis: [{
            type: 'value',
            axisLine: {
              show: false, // 不显示坐标轴线
            },
            axisTick:{
              show:false // 不显示坐标轴刻度线
            },
            splitLine: {
              show: true,
              lineStyle:{
                color: ['#66687C'],
                width: 1,
                type: 'solid'
              }
        　　},
            axisLabel: {
                formatter: '{value}',
                color: "#66687C",
            }
          },{
            type: 'value',
            splitLine:{
              show:false // 不显示网格线
            },
            axisLine: {
              show: false, // 不显示坐标轴线
            },
            axisTick:{
              show:false // 不显示坐标轴刻度线
            },
            axisLabel: {
              formatter: '{value} %',
              color: "#66687C",
            }
          }],
          series: [{
            name: '违规量',
            type: 'bar',
            barWidth : 10,
            color: '#4684FF',
            data: list[1],
          },{
            name: `${this.$store.state.globalLowPrice}率`,
            type: 'line',
            yAxisIndex: 1,
            barWidth : 30,
            color: '#3F96A5',
            data: list[0],
          }]
        };
        // 使用刚指定的配置项和数据显示图表。
        myChart.setOption(option);
      },
      // 各平台店铺销量分析
      drawChart2(list,dateList) {
        // 基于准备好的dom，初始化echarts实例  这个和上面的main对应
        let myChart = this.$echarts.init(document.getElementById("main2"));
        // 指定图表的配置项和数据
        let option = {
          tooltip: {
            trigger: 'axis',
          },
          legend: {
            data: ["违规量",`${this.$store.state.globalLowPrice}率`],
            textStyle: {
              color: '#66687C',   // 设置图例文本颜色
            }
          },
          xAxis: {
            type: 'category',
            data: dateList,
            axisPointer: {
              type: 'shadow'
            },
            axisLabel: {
              color: "#66687C",
            },
            axisLine: {
              lineStyle: {
                color: '#66687C'   // 将刻度线颜色修改为红色
              }
            },
          },
          yAxis: [{
            type: 'value',
            axisLine: {
              show: false, // 不显示坐标轴线
            },
            axisTick:{
              show:false // 不显示坐标轴刻度线
            },
            splitLine: {
              show: true,
              lineStyle:{
                color: ['#66687C'],
                width: 1,
                type: 'solid'
              }
            },
            axisLabel: {
                formatter: '{value}',
                color: "#66687C",
            },
            // interval: 10,
            // max: function (value) {
            //   console.log(value)
            //   // return value.max * 2
            // }
          },{
            type: 'value',
            splitLine:{
              show:false // 不显示网格线
            },
            axisLine: {
              show: false, // 不显示坐标轴线
            },
            axisTick:{
              show:false // 不显示坐标轴刻度线
            },
            axisLabel: {
              formatter: '{value} %',
              color: "#66687C",
            }
          }],
          series: [{
            name: '违规量',
            type: 'bar',
            barWidth : 10,
            color: '#4684FF',
            data: list[1],
          },{
            name: `${this.$store.state.globalLowPrice}率`,
            type: 'line',
            yAxisIndex: 1,
            barWidth : 30,
            color: '#3F96A5',
            data: list[0],
          }]
        };
        // 使用刚指定的配置项和数据显示图表。
        myChart.setOption(option);
      }
    },
  };
</script>
<style>
  .dv-decoration-5 polyline {
    stroke: #5783ff !important;
  }
  .dv-scroll-ranking-board .ranking-info .info-name {
    text-overflow: ellipsis !important;
    overflow: hidden !important;
    white-space: nowrap !important;
  }
</style>
<style lang="scss" scoped>
#dataSize {
  height: 100vh;
  font-family: "微软雅黑";
  .screenContainer {
    background-image:url('https://hawksights.obs.cn-east-2.myhuaweicloud.com/system/allBj.png');
    width: 100%;
    overflow: auto;
    position: fixed;
    top: 0;
    left: 0;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
  }
  .headerClass {
    background-image:url('https://hawksights.obs.cn-east-2.myhuaweicloud.com/system/headerBj.png');
    width: 100%;
    height: 120px;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
  }
  .headerTitle {
    color: white;
    height: 85px;
    line-height: 94px;
    font-size: 30px;
    margin-left: 100px;
    float: left;
  }
  .headerTime {
    color: rgba(255, 255, 255, 0.6);
    height: 85px;
    line-height: 94px;
    font-size: 20px;
    margin-right: 50px;
    float: right;
    font-family: "fantasy",
  }
  .jiangbeiClass {
    width: 27px;
    float: left;
    margin-top: 5px;
  }
  .jiangbeiTitle {
    float: left;
    margin-left: 10px;
  }
  .platClass {
    clear: both;
    color: white;
    height: 50px;
    padding: 20px 70px 0px 70px;
  }
  .actItem {
    float: left;
    font-size: 18px;
    color: rgb(255, 255, 255);
    background: center center / contain no-repeat rgb(26, 125, 255);
    border-radius: 4px;
    margin-right: 10px;
    padding: 5px 10px;
    cursor: pointer;
  }
  .noItem {
    float: left;
    font-size: 18px;
    color: rgba(255, 255, 255, 0.6);
    margin-right: 10px;
    padding: 5px 10px;
    cursor: pointer;
  }
  .actItem2 {
    float: left;
    font-size: 12px;
    color: rgb(255, 255, 255);
    background: center center / contain no-repeat rgb(26, 125, 255);
    border-radius: 20px;
    margin-right: 20px;
    padding: 5px 15px;
    cursor: pointer;
    margin-top: 3px;
  }
  .noItem2 {
    float: left;
    font-size: 12px;
    color: rgba(255, 255, 255, 0.6);
    margin-right: 17px;
    padding: 5px 15px;
    cursor: pointer;
    margin-top: 3px;
  }
  .liangOne {
    clear: both;
    background: linear-gradient(270deg, rgb(87, 131, 255) 0%, rgb(15, 79, 255) 100%);
    padding: 20px;
    width: 28%;
    margin-right: 20px;
    color: white;
    font-size: 16px;
    float: left;
  }
  .liangTwo {
    background: linear-gradient(270deg, rgb(87, 131, 255) 0%, rgb(15, 79, 255) 100%);
    padding: 20px;
    width: calc(100% - 70px);
    color: white;
    font-size: 16px;
    float: left;
  }
}
</style>
